<template>
  <v-row class="pa-2" no-gutters>
    <v-col class="pa-2 mb-4 sticky-md" cols="12" md="4" style="top: 12px">
      <v-tabs
        v-model="qrShow"
        background-color="grey lighten-3 pa-1"
        class="rounded-pill mx-auto pa-1"
        color="primary"
        height="48"
        style="width: fit-content"
      >
        <v-tab :disabled="e6 <= 1" :ripple="true"> مشاهده QR </v-tab>

        <v-tab :ripple="true"> پیش نمایش </v-tab>
        <v-tab :ripple="true" :disabled="e6 <= 1">تعرفه‌ها</v-tab>

      </v-tabs>
    </v-col>

    <v-col v-show="$vuetify.breakpoint.mdAndUp" cols="8" />

    <v-col
      class="pa-2 sticky-md"
      cols="12"
      md="4"
      style="top: 110px; height: fit-content"
    >
      <v-tabs-items
        v-model="qrShow"
        class="overflow-visible mb-4 mb-md-0"
        touchless
      >
        <v-tab-item>
          <qr-maker :loading="loading" :svg="svgMade" />
          <v-btn class="btn-download" @click="showDialog = true">
            <v-icon>mdi-progress-download</v-icon>
            {{ $t("download_qr") }}          </v-btn>
        </v-tab-item>

        <v-tab-item>
          <component is="qrDiscount" :data="cardTexts" />
        </v-tab-item>
        <v-tab-item v-if="!!info?.id && e6>1">
          <Tariffs :id_qr="info.id" :qrtype="'VisitCard'" />
        </v-tab-item>

      </v-tabs-items>
    </v-col>

    <v-col class="pa-2 px-0" cols="12" md="8">
      <template>
        <v-stepper v-model="e6" class="px-0 mx-0 qr-stepper" flat vertical>
          <v-stepper-step :complete="e6 > 1" class="px-0 px-md-4" step="1">
            <div class="row justify-center">
              <div class="col-md-12">
                <p>وارد کردن کیوآر</p>
              </div>

              <div class="col-md-9 mt-0 pt-0">
                <qr-address-field
                  id="qr-address"
                  v-model="dtUrl"
                  :disabled="e6 > 1"
                  :error-messages="errors['identifier']"
                  append-icon="mdi-web"
                  class="mt-0 pt-0"
                  dense
                  outlined
                  persistent-hint
                  :key="$t('qrAddressUpdate.hints.allowedChars')"
                  :hint="$t('qrAddressUpdate.hints.allowedChars')"

                />
              </div>
            </div>
          </v-stepper-step>

          <v-stepper-content class="pr-1 mx-0 mr-md-7 px-md-4" step="1">
            <list-expansion :components="specialInfo" :data="cardTexts" flat />

            <qr-generator />

            <div class="col-md-12">
              <next-btn style="background: #1b8d39" @click="markQr(false)" />
            </div>
          </v-stepper-content>

          <v-stepper-step :complete="e6 > 2" class="px-0 px-md-4" step="2"
            >تنظیمات کیوآر</v-stepper-step
          >

          <v-stepper-content class="pr-1 mx-0 mr-md-7 px-md-4" step="2">
            <qr-management ref="qrManage" :qrId="shortId" />

            <div class="row mx-auto">
              <div class="col-md-6">
                <prev-btn @click="e6 = 1" />
              </div>

              <div class="col-md-6">
                <next-btn @click="setSettings" />
              </div>
            </div>
          </v-stepper-content>

          <v-stepper-step :complete="e6 > 3" class="px-0 px-md-4" step="3"
            >دیزاین کیوآر</v-stepper-step
          >

          <v-stepper-content class="pr-1 mx-0 mr-md-7 px-md-4" step="3">
            <qr-customize v-model="qrDesign" />

            <div class="row mx-auto">
              <div class="col-md-6">
                <prev-btn
                  v-if="finish"
                  style="background: orange"
                  text="ویرایش"
                  @click="goto(`qr/${createdId}/edit`)"
                />

                <prev-btn v-else @click="e6 = 2" />
              </div>

              <div class="col-md-6">
                <v-btn
                  v-if="finish"
                  class="btn-download float-left"
                  @click="showDialog = true"
                >
                  <v-icon>mdi-progress-download</v-icon>
                  {{ $t("download_qr") }}                </v-btn>

                <next-btn v-else text="ثبت" @click="qrUpdate(true)" />
              </div>
            </div>
          </v-stepper-content>
        </v-stepper>
      </template>
    </v-col>

    <custom-popup
      v-model="showDialog"
      :cons="cons"
      hide-confirm
      max-width="900"
      transition="dialog-bottom-transition"
    >
      <template v-slot:helpinfo>
        <help-info
          :element-name="`${serviceName}-${componentName}-data-show-download-d`"
          :service-name="serviceName"
          :help-data="helpData"
          class="buttoninfo"
          label="دانلود کیوآر"
        />
      </template>
      <v-card class="px-5">
        <download-file
          v-if="showDialog"
          :data="{ theme: '', data: cardTexts }"
          :dynam="true"
          :eye-style="eyeStyle"
          :qr-style="qrStyle"
          :svg="svgMade"
          destination_url="https://t.qrland.ir/"
          type="visitCard"
        />
      </v-card>
    </custom-popup>
  </v-row>
</template>

<script>
import qrDiscount from "../qrland/components/qrDiscount";
import QrGenerator from "../qrland/components/qrGenerator";
import QrMaker from "../qrland/components/qrMaker";
import { Bus, debounce } from "@/main";
import QrCustomize from "../qrland/components/qrCustomize";
import DownloadFile from "../qrland/downloadFile";
import QrManagement from "../qrland/components/qrManage/qrManagement";
import ListExpansion from "../../content/fragments/listExpansion";
import NextBtn from "../../content/fragments/nextBtn";
import PrevBtn from "../../content/fragments/prevBtn";
import QrAddressField from "../../content/fragments/qrAddressField";
import { mapGetters } from "vuex";
import Tariffs from "../../components/Tariffs/Tariffs.vue";

export default {
  name: "cardVisit",
  components: {
    QrAddressField,
    PrevBtn,
    NextBtn,
    ListExpansion,
    QrManagement,
    DownloadFile,
    QrCustomize,
    QrMaker,
    QrGenerator,
    qrDiscount,
    Tariffs
  },
  data() {
    return {
      qrDesign: {},
      cons: { title: "دانلود کیوآر" },
      e6: 1,
      errors: {},
      createdId: null,
      shortId: null,
      finish: true,
      loading: false,
      showDialog: false,
      customTheme: [{ name: "qrDiscount", value: "" }],
      specialInfo: [
        {
          name: "textCardDiscount",
          value: "",
          title: "اطلاعات کارت تخفیف",
          subtitle: "",
          icon: "cart-percent",
        },
      ],
      headColor: "linear-gradient(to right , #D81A1AFF, #2115A7FF)",
      bodyColors: "",
      eyeStyle: "",
      qrStyle: "",
      qrSize: "",
      dtUrl: null,
      cardTexts: {
        pallete: {},
        isGradient: false,
        companyName: "بوتیک قرمز",
        titleCompany: " تخفیف عیدانه کلیه محصولات",
        titleDiscount: "20٪ تخفیف",
        giveCopan: "کوپن  تخفیف بگیرید ",
        descriptionDiscount:
          "تمام خریدهای تعطیلات خود را در اوایل امسال انجام دهید! اجناس با تخفیف روی همه لباس‌ها، کیف‌ها و موارد دیگر..",
        companyNumber: "02191017077",
        location:
          "تهران، خیابان شریعتی ، بعد از پل سید خندان، بن بست خندان ، پلاک 6 ",
        city: "",
        photo: {},
        province: "",
        country: "",
        socialMedia: {},
        center: [51.420296, 35.732379],
        coordinates: [51.420296, 35.732379],
        address: "",
        apiKey:
          "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImp0aSI6ImZhZjI0ZjA0Y2U2NTQ2ZDAyYzMwNjBmMzAxYWY0NTMxYjhkOTEwODVhMDQ3MGY1ZDc3YjYwY2M4OGRiNjVkZjZkMjIyZWNkZjNmMTJkYmExIn0.eyJhdWQiOiIyMDI5NSIsImp0aSI6ImZhZjI0ZjA0Y2U2NTQ2ZDAyYzMwNjBmMzAxYWY0NTMxYjhkOTEwODVhMDQ3MGY1ZDc3YjYwY2M4OGRiNjVkZjZkMjIyZWNkZjNmMTJkYmExIiwiaWF0IjoxNjcwNjg5MDc4LCJuYmYiOjE2NzA2ODkwNzgsImV4cCI6MTY3MzE5NDY3OCwic3ViIjoiIiwic2NvcGVzIjpbImJhc2ljIl19.h-KYgigwSQbp9KYjIjWgBLQRpMy6ABa40dyF4pF99UmndnhDNs-fckFePIdRPkm7GlggWm9yKphj_TJ5b9TyA8m1_gNarjRiPzhAS5ZNGNUaSfnGHA1cUbc71DuUKgohAe2sOmXUkKin0q-ErzDdCczJjLVc218dRkCxLuJIrAY5yZ5yVgK79-Q6misDYP3yLpWaV5uDA3a1VzXppq4G9hm0GCGmsef_WryEx9z1fFuOzoVbuNj2yEKn3mBi2vAyKvV1HRMKMoXy_KLTk8xy-GsSQArOxKvw4Nk8Nvuks0WzSlLygNncQozltpm5Z4kueep-0TrI4xzx6uSjuk20vg",
      },
      qrShow: 1,
      svgMade: "",
      destinationUrl: "",
    };
  },

  methods: {
    markQr(final = false) {
      if (!this.dtUrl || this.dtUrl.length < 3) {
        this.$toast.error("لطفا آدرس کیوآر را به درستی وارد نمایید!");
        return;
      }

      this.loading = true;
      let obj = {
        type: "VisitCard",
        format: "svg",
        color: ["#001554"],
        qrType: "dynamic",

        size: this.qrSize ? this.qrSize : 248,
        eye: this.eyeStyle ? this.eyeStyle : undefined,
        style: this.qrStyle ? this.qrStyle : undefined,
        margin: 0,
        destination_url: "https://qr2.in/",
        VisitCard: JSON.stringify({
          theme: "",
          data: this.cardTexts,
        }),
        qr: {
          section: "#link",
          link: "https://qr2.in/",
          backcolor: "#ffffff",
          frontcolor: "#000000",
          gradient_color: "#000000",
          marker_out_color: "#000000",
          marker_in_color: "#000000",
          marker_top_right_outline: "#000000",
          marker_top_right_center: "#000000",
          marker_bottom_left_outline: "#000000",
          marker_bottom_left_center: "#000000",
          framecolor: "#000000",
          optionlogo: "none",
          "logo-size": 100,
          marker: "default",
          marker_in: "default",
          outer_frame: "none",
          framelabel: "SCAN ME",
          label_font: "AbrilFatface.svg",
          "label-text-size": 100,
          size: "248",
          level: "M",
        },
      };
      if (this.dtUrl && this.dtUrl.length > 0) {
        obj.identifier = this.dtUrl;
      }

      this.$api
        .post("/v1/Qr", obj)
        .then(({ data }) => {
          this.finish = final;
          this.loading = false;
          this.preview(data.data.short_url.destination_url);
          this.createdId = data.data.id;
          this.shortId = data.data.short_url.id;
          this.destinationUrl = data.data.short_url.destination_url;
          this.svgMade = data.data.svg;
          this.qrShow = 0;
          this.$toast.success("کارت تخفیف شما با موفقیت ساخته شد.");
          if (this.e6 === 1) {
            this.e6 = 2;
          }
        })
        .catch(({ response }) => {
          this.errors = response.data.errors;
          let el = document.getElementById("qr-address");
          el.scrollIntoView({ behavior: "smooth", block: "center" });
          this.loading = false;
          // this.$toast.error('خطای سرور!')
        })
        .finally(() => {
          this.loading = false;
        });
    },
    preview(link) {
      this.loading = true;
      this.$api
        .post("/v1/Qr/preview", {
          section: "#link",
          link: link,
          backcolor: !this.qrDesign.qrStyleColors?.backcolor
            ? "#ffffff"
            : this.qrDesign.qrStyleColors?.backcolor,
          gradient_color: !this.qrDesign.qrStyleColors?.gradient_color
            ? "#8900d5"
            : this.qrDesign.qrStyleColors?.gradient_color,
          frontcolor: !this.qrDesign.qrStyleColors?.frontColor
            ? "#000000"
            : this.qrDesign.qrStyleColors?.frontColor,
          gradient: this.qrDesign.qrStyleColors?.gradient ? "on" : undefined,
          pattern: this.qrDesign.qrStyleColors.pattern,
          marker_in: this.qrDesign.MarkerCenter.eyePattern,
          marker_in_color: this.qrDesign.MarkerCenter.main,
          markers_color: "on",
          marker: this.qrDesign.QrMarkOut.markOutPattern,
          different_markers_color:
            this.qrDesign.QrMarkOut.different_markers_color ||
            this.qrDesign.MarkerCenter.different_markers_color
              ? "on"
              : undefined,
          marker_out_color: this.qrDesign.QrMarkOut.main,
          marker_top_right_outline: this.qrDesign.QrMarkOut.topRight,
          marker_top_right_center: this.qrDesign.MarkerCenter.topRight,
          marker_bottom_left_outline: this.qrDesign.QrMarkOut.bottomLeft,
          marker_bottom_left_center: this.qrDesign.MarkerCenter.bottomLeft,
          custom_frame_color: this.qrDesign.QrFrame?.different_markers_color
            ? "on"
            : undefined,
          outer_frame: this.qrDesign.QrFrame.framePattern,
          framecolor: this.qrDesign.QrFrame.main,
          framelabel: this.qrDesign.QrFrame.text,
          optionlogo: this.qrDesign.LogoImg.logoImg,
          no_logo_bg: this.qrDesign.LogoImg.noBg ? "on" : undefined,
          "logo-size": this.qrDesign.LogoImg.logoSize,
          label_font: "AbrilFatface.svg",
          "label-text-size": "100",
          size: "248",
          level: "H",
        })
        .then((res) => {
          this.loading = false;
          this.svgMade = res.data.data;
        })
        .catch((err) => {
          this.loading = false;
          // this.$toast.error('خطای سرور!')
        })
        .finally(() => {
          this.loading = false;
        });
    },
    async setSettings() {
      const res = await this.$refs.qrManage.update();
      this.e6 = 3;
    },
    qrUpdate(final = false) {
      this.loading = true;

      const data = new URLSearchParams();
      data.append("type", "VisitCard");
      data.append("format", "svg");
      data.append("qrType", "dynamic");
      data.append("margin", "0");
      data.append("id", this.createdId);
      data.append("svg", this.svgMade);
      data.append(
        "VisitCard",
        JSON.stringify({
          theme: "",
          data: this.cardTexts,
        })
      );
      data.append(
        "qr[backcolor]",
        !this.qrDesign.qrStyleColors?.backcolor
          ? "#ffffff"
          : this.qrDesign.qrStyleColors?.backcolor
      );
      data.append(
        "qr[gradient_color]",
        !this.qrDesign.qrStyleColors?.gradient_color
          ? "#000000"
          : this.qrDesign.qrStyleColors?.gradient_color
      );
      data.append(
        "qr[frontcolor]",
        !this.qrDesign.qrStyleColors?.frontColor
          ? "#000000"
          : this.qrDesign.qrStyleColors?.frontColor
      );
      data.append(
        "qr[gradient]",
        this.qrDesign.qrStyleColors?.gradient ? "on" : undefined
      );
      data.append("qr[pattern]", this.qrDesign.qrStyleColors.pattern);
      data.append("qr[marker_in]", this.qrDesign.MarkerCenter.eyePattern);
      data.append("qr[marker_in_color]", this.qrDesign.MarkerCenter.main);
      data.append("qr[markers_color]", "on");
      data.append("qr[marker]", this.qrDesign.QrMarkOut.markOutPattern);
      data.append(
        "qr[different_markers_color]",
        this.qrDesign.QrMarkOut.different_markers_color ||
          this.qrDesign.MarkerCenter.different_markers_color
          ? "on"
          : undefined
      );
      data.append("qr[marker_out_color]", this.qrDesign.QrMarkOut.main);
      data.append(
        "qr[marker_top_right_outline]",
        this.qrDesign.QrMarkOut.topRight
      );
      data.append(
        "qr[marker_top_right_center]",
        this.qrDesign.MarkerCenter.topRight
      );
      data.append(
        "qr[marker_bottom_left_outline]",
        this.qrDesign.QrMarkOut.bottomLeft
      );
      data.append(
        "qr[marker_bottom_left_center]",
        this.qrDesign.MarkerCenter.bottomLeft
      );
      data.append(
        "qr[custom_frame_color]",
        this.qrDesign.QrFrame?.different_markers_color ? "on" : undefined
      );
      data.append("qr[outer_frame]", this.qrDesign.QrFrame.framePattern);
      data.append("qr[framecolor]", this.qrDesign.QrFrame.main);
      data.append("qr[framelabel]", this.qrDesign.QrFrame.text);
      data.append("qr[optionlogo]", this.qrDesign.LogoImg.logoImg);
      data.append(
        "qr[no_logo_bg]",
        this.qrDesign.LogoImg.noBg ? "on" : undefined
      );
      data.append("qr[label_font]", "AbrilFatface.svg");
      data.append("qr[size]", "248");
      data.append("qr[level]", "H");
      data.append('qr["logo-size"]', this.qrDesign.LogoImg.logoSize);
      data.append('qr["label-text-size"]', "100");

      this.$api
        .put("/v1/Qr/update", data, {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
        })
        .then((res) => {
          this.finish = final;
          this.$toast.success("کیوآر کارت تخفیف شما باموفقیت ویرایش شد.");
        })
        .catch((err) => {
          this.loading = false;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },

  mounted() {
    this.cardTexts.socialMedia = {
      address: [
        {
          hint: " لطفا آدرس آدرس خودرا وارد کنید ",
          label: "آدرس",
          url: "www.qrland.ir",
          img: "/media/socialIcon/40icon/location.svg",
          svg: "svgLocation",
        },
        {
          hint: " لطفا آدرس آدرس خودرا وارد کنید ",
          label: "آدرس",
          url: "www.qr.terminalads.com",
          img: "/media/socialIcon/40icon/location.svg",
          svg: "svgLocation",
        },
      ],
      instagram: [
        {
          hint: " لطفا آدرس اینستاگرام خودرا وارد کنید ",
          label: "اینستاگرام",
          url: "https://instagram.com/terminalads",
          img: "/media/socialIcon/40icon/instagram.svg",
          svg: "svgInstagram",
        },
      ],
      whatsapp: [
        {
          hint: " لطفا آدرس واتساپ خودرا وارد کنید ",
          label: "واتساپ",
          url: "https://wa.me/982191017077",
          img: "/media/socialIcon/40icon/whatsapp.svg",
          svg: "svgWhatsapp",
        },
      ],
    };

    this.qrDesign = {
      qrStyleColors: {
        backcolor: "",
        frontColor: "",
        gradient_color: "",
        gradient: false,
        pattern: "default",
      },
      MarkerCenter: {
        topRight: "",
        bottomLeft: "",
        main: "",
        different_markers_color: false,
        eyePattern: "default",
      },
      QrMarkOut: {
        topRight: "",
        bottomLeft: "",
        markOutPattern: "default",
        main: "",
        different_markers_color: false,
      },
      QrFrame: {
        main: "",
        text: "SCAN ME",
        framePattern: "none",
        different_markers_color: false,
      },
      LogoImg: { noBg: false, logoSize: 100, logoImg: "none" },
    };

    Bus.$on("colorPalette", (value) => {
      this.cardTexts.pallete = value;
    });

    Bus.$on("socialMedias", (value) => {
      this.cardTexts.socialMedia = value;
    });

    Bus.$on("uploader", (value) => {
      this.cardTexts.photo = value;
    });

    Bus.$on("gradientType", (value) => {
      this.cardTexts.isGradient = value;
    });

    Bus.$on("eyeStyle", (value) => {
      this.eyeStyle = value;
    });

    Bus.$on("qrStyle", (value) => {
      this.qrStyle = value;
    });
  },

  computed: {
    ...mapGetters("qr", ["visitCardTransition", "hasWelcome"]),
  },

  watch: {
    qrDesign: {
      handler() {
        this.loading = true;
        if (this.destinationUrl) {
          debounce(() => {
            this.preview(this.destinationUrl);
          }, 3000);
        }
      },
      deep: true,
    },
    visitCardTransition(val) {
      this.cardTexts.transition = val;
    },
    hasWelcome(val) {
      this.cardTexts.hasWelcome = val;
    },
    eyeStyle() {
      this.markQr(false);
    },
    qrStyle() {
      this.markQr(false);
    },
    qrSize() {
      this.markQr(false);
    },
  },
};
</script>

<style scoped>
.v-tab--active {
  background-color: var(--v-primary-base) !important;
  border-radius: 50px;
  color: white;
}
</style>
